import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import axios from "axios";
import { BASE_URL, security_key } from "../../../global";

// Styled component for center label (if needed)
const StyledText = styled("text")(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 20,
}));

// Define the center label component (if needed)
function PieCenterLabel({ children }) {
    const { width, height, left, top } = {
        width: 400,
        height: 200,
        left: 0,
        top: 0,
    }; // Placeholder values
    return (
        <StyledText x={left + width / 2} y={top + height / 2}>
            {children}
        </StyledText>
    );
}

const DonutChart = () => {
    const [loading, setLoading] = useState(false);

    const [chartData, setChartData] = useState([]);

    // const [chartData, setChartData] = useState([
    //     {
    //         value: 0,
    //         label: "Payout Received",
    //     },
    //     {
    //         value: 0,
    //         label: "Payout Pending",
    //     },
    //     {
    //         value: 0,
    //         label: "Total Earnings",
    //     },
    // ]);
    const [totalEarnings, setTotalEarnings] = useState(0);
    const [thisMonthEarnings, setThisMonthEarnings] = useState(0);

    useEffect(() => {
        getDonutChartData();
    }, []);

    const getDonutChartData = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getDonutChartData",
                pk_user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;

            if (Object.keys(output).length > 0) {
                if (output.payoutPending && output.totalEarnings) {
                    setChartData([
                        { value: parseInt(output.payoutPending), label: "Payout Pending" },
                        { value: parseInt(output.totalEarnings), label: "Total Earnings" },
                    ]);
                }

                if (output.totalEarnings) {
                    setTotalEarnings(parseInt(output.totalEarnings));
                }
                if (output.thisMonthEarnings) {
                    setThisMonthEarnings(parseInt(output.thisMonthEarnings));
                }
            } else {
                // toast.error("Oops! Something went wrong.", { autoClose: 3000 });
            }
        } catch (error) {
            // toast.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Donut chart options and series
    // const donutChartOptions = {
    //     chart: {
    //         type: "donut",
    //         height: "100%", // Ensure it adjusts to container height
    //     },
    //     labels: chartData.map((item) => item.label),
    //     colors: ["#000", "#333", "#666", "#999"], // Customize colors as needed
    //     dataLabels: {
    //         enabled: true,
    //         formatter: (val, opts) => {
    //             return `${val.toFixed(2)}%`;
    //         },
    //     },
    //     legend: {
    //         position: "right",
    //         verticalAlign: "center",
    //     },
    //     plotOptions: {
    //         pie: {
    //             donut: {
    //                 size: "60%", // Adjust the size of the donut
    //             },
    //         },
    //     },
    //     responsive: [
    //         {
    //             breakpoint: 480,
    //             options: {
    //                 chart: {
    //                     width: "100%", // Make chart responsive
    //                 },
    //                 legend: {
    //                     position: "bottom",
    //                 },
    //             },
    //         },
    //     ],
    // };

    const isDataAvailable = chartData.some((item) => item.value > 0);

    const donutChartOptions = {
        chart: {
            type: "donut",
            height: "100%", // Ensure it adjusts to container height
        },
        labels: chartData.length > 0 ? chartData.map((item) => item.label) : [], // Only map labels if data exists
        colors: ["#000", "#666", "#999"], // Customize colors as needed
        dataLabels: {
            enabled: true,
            formatter: (val, opts) => {
                return `${val.toFixed(2)}%`;
            },
        },
        legend: {
            position: "right",
            verticalAlign: "center",
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "60%", // Adjust the size of the donut
                },
            },
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: "100%", // Make chart responsive
                    },
                    legend: {
                        position: "bottom",
                    },
                },
            },
        ],
        // Display a message when no data is available
        series: chartData.length > 0 ? chartData.map((item) => item.value) : [100], // If no data, show an empty chart with 100% (or adjust as needed)
        annotations: {
            yaxis:
                chartData.length === 0
                    ? [
                        {
                            y: 50,
                            borderColor: "#FF0000",
                            label: {
                                text: "No Data Available",
                                style: {
                                    color: "#FF0000",
                                    fontSize: "16px",
                                },
                            },
                        },
                    ]
                    : [],
        },
    };

    const donutChartSeries = chartData.map((item) => item.value);

    return (
        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
            <Box width="100%" maxWidth={500}>
                {isDataAvailable ? (
                    <Chart
                        options={donutChartOptions}
                        series={donutChartSeries}
                        type="donut"
                        width="100%"
                        height={380} // Adjust height as needed
                    />
                ) : (
                    <Typography variant="h6" color="textSecondary" align="center" display="flex" justifyContent="center" alignItems="center" height={380}>
                        No Data Available
                    </Typography>
                )}
            </Box>

            <Box className="value-home mt-2 d-flex w-100 justify-content-around">
                <Box className="value-box">
                    <Typography variant="h6" component="h4">
                        Total Earning
                    </Typography>
                    <Typography variant="h6" component="p" fontWeight="bold">
                        ${totalEarnings}
                    </Typography>
                </Box>
                <Box className="value-box">
                    <Typography variant="h6" component="h4">
                        This Month Earning
                    </Typography>
                    <Typography variant="h6" component="p" fontWeight="bold">
                        ${thisMonthEarnings}
                    </Typography>
                </Box>
            </Box>

            <style jsx>
                {`
                    .rect.MuiChartsLegend-mark {
                        display: none !important;
                    }
                `}
            </style>
        </Box>
    );
};

export default DonutChart;
